import dayjs from 'dayjs';

import { getWeekdayOccurrenceInMonth } from './getWeekdayOccurrenceInMonth.ts';
import { isLastOccurrenceOfWeekday } from './isLastOccurrenceOfWeekday.ts';

export const getDateDetails = (date: Date) => {
  const parsedDate = dayjs(date);

  const dayOfMonth = parsedDate.date();
  const weekdayOccurrenceInMonth = getWeekdayOccurrenceInMonth(date);
  const isLastWeekdayOccurrence = isLastOccurrenceOfWeekday(date);

  return { dayOfMonth, isLastWeekdayOccurrence, weekdayOccurrenceInMonth };
};
